export type PaginationItem = number | 'start-ellipsis' | 'end-ellipsis';

function range(start: number, end: number): number[] {
    return Array.from({ length: Math.max(end - start + 1, 0) }, (_, index) => start + index);
}

/**
 * The page buttons for a pager on `page` of `pageCount` (both 1-based): the first and last page, the
 * current one with a neighbour either side, and an ellipsis for each gap. A gap of a single page shows
 * that page instead, so the row keeps one length as the current page moves.
 */
export function paginationItems(pageCount: number, page: number): PaginationItem[] {
    const siblingsStart = Math.max(Math.min(page - 1, pageCount - 4), 3);
    const siblingsEnd = Math.min(Math.max(page + 1, 5), pageCount - 2);

    return [
        1,
        ...(siblingsStart > 3 ? ['start-ellipsis' as const] : pageCount > 3 ? [2] : []),
        ...range(siblingsStart, siblingsEnd),
        ...(siblingsEnd < pageCount - 2 ? ['end-ellipsis' as const] : pageCount > 2 ? [pageCount - 1] : []),
        ...(pageCount > 1 ? [pageCount] : []),
    ];
}
